import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Calendar = () => {
  const [alltimes, setalltimes] = useState([]);
  const [selectedTime, setSelectedTime] = useState(null);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');

  useEffect(() => {
    axios
      .get(`https://api.kgphotographies.com/api/getalltimes`)
      .then((res) => {
        console.log(res.data);
        setalltimes(res.data);
      })
      .catch((err) => {
        console.log(err.response);
      });
  }, []);

  const handleButtonClick = (time) => {
    setSelectedTime(time);
    // You can show a modal or set a state to render a form dynamically
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    // Perform your logic for submitting the form (e.g., sending email and name to the server)
    console.log('Name:', name);
    console.log('Email:', email);
    // Reset form fields and close modal or hide form
    setSelectedTime(null);
    setName('');
    setEmail('');
  };

  return (
    <div>
      <div>
        <h2>My Availability:</h2>
      </div>
      <div>
        <ul className='list-group list-group-flush'>
          {alltimes.map((time) => (
            <li key={time.id} className='list-group-item'>
              {new Date(time.date).toLocaleDateString()} {time.startTime} - {time.endTime}
              <div>
              <button onClick={() => handleButtonClick(time)}>Book</button>
              </div>
            </li>
          ))}
        </ul>
      </div>

      {/* Modal or Form */}
      {selectedTime && (
        <div>
          <h3>Book Time</h3>
          <form onSubmit={handleFormSubmit}>
            <label>
              Name:
              <input type="text" value={name} onChange={(e) => setName(e.target.value)} required />
            </label>
            <br />
            <label>
              Email:
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </label>
            <br />
            <button type="submit">Submit</button>
          </form>
        </div>
      )}
    </div>
  );
};

export default Calendar;